import React from 'react';
import BlogFAQSection from './BlogFAQSection';
import StructuredDataFAQ from '@/components/seo/StructuredDataFAQ';
import { blogFAQData } from '@/data/faq/blog-faq';

const BlogFAQComponent = () => {
  const faqItems = blogFAQData;

  return (
    <section className="section-spacing bg-joerg-50">
      <StructuredDataFAQ faqItems={faqItems} pageName="Blog" />
      <div className="container max-w-4xl">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Häufige Fragen
          </span>
          <h2 className="animate-fade-in mb-6" style={{ animationDelay: '100ms' }}>
            Über meinen Blog
          </h2>
          <p className="text-joerg-600 text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '200ms' }}>
            Alles über die Inhalte, Veröffentlichungen und Nutzung meiner Blog-Artikel zu Coaching und Persönlichkeitsentwicklung.
          </p>
        </div>
        
        <BlogFAQSection 
          items={faqItems} 
          title="" 
        />
      </div>
    </section>
  );
};

export default BlogFAQComponent;